export const BET_NEVER_REMIND = "bet_never_remind"